import React from 'react'

function Sticker(){
    return(
        <img src = "./image/studying.png" className="stick"/>
    )
}

export default Sticker